module.exports = __webpack_public_path__ + "img/team-3.ce365fa2.png";